import { addModuleForInstantiationFromHydrationData, addModuleForInstantiationFromMutation, addModuleForInstantiationFromDom } from '../core/instantiation';
import Logger from '../utilities/logger';
// Default options for the instantiate() function
const defaultInstantiateOptions = {
    fromHydrationQueue: true,
    fromDom: false,
    fromMutation: false,
};
const catalogItemConfigurations = new Map();
const doesConfigurationExist = (constructor) => catalogItemConfigurations.has(constructor);
export const addConfiguration = (constructor, moduleName, options = {}) => {
    const mergedOptions = {
        ...options,
        instantiate: {
            ...defaultInstantiateOptions,
            ...('instantiate' in options ? options.instantiate : {}),
        },
        name: moduleName,
    };
    if (!doesConfigurationExist(constructor)) {
        catalogItemConfigurations.set(constructor, mergedOptions);
        if (mergedOptions.instantiate.fromHydrationQueue) {
            addModuleForInstantiationFromHydrationData(moduleName);
        }
        if (mergedOptions.instantiate.fromDom) {
            addModuleForInstantiationFromDom(moduleName);
        }
        if (mergedOptions.instantiate.fromMutation) {
            addModuleForInstantiationFromMutation(moduleName);
        }
    }
};
export const getConfiguration = (constructor) => {
    if (!doesConfigurationExist(constructor)) {
        Logger.error(`Configuration requested for un-registered module '${constructor.name}'`);
        return null;
    }
    return catalogItemConfigurations.get(constructor);
};
export const getModuleName = (constructor) => {
    if (!doesConfigurationExist(constructor)) {
        Logger.error(`Module name requested for un-registered module '${constructor.name}'`);
        return null;
    }
    return getConfiguration(constructor).name;
};
export const getCatalogItemsInstantiatedFromHydration = () => (Array.from(catalogItemConfigurations.values())
    .filter((options) => options.instantiate.fromHydrationQueue)
    .map((options) => options.name));
export const catalogItem = (moduleName, options) => (target) => {
    addConfiguration(target, moduleName, {
        ...options,
    });
};
export const clearConfigurations = () => {
    catalogItemConfigurations.clear();
};
